import { PageLayout } from "@/components/layout/PageLayout";

const Privacy = () => {
  return (
    <PageLayout>
      <div className="container mx-auto px-4 py-16 max-w-4xl">
        <h1 className="text-4xl font-bold text-foreground mb-4">Politica de Confidențialitate (GDPR) – OptiRO.ai (MVP)</h1>
        <p className="text-muted-foreground mb-8">Ultima actualizare: Februarie 2026</p>

        <div className="prose prose-slate dark:prose-invert max-w-none space-y-8">
          <p className="text-muted-foreground leading-relaxed">
            Această Politică explică modul în care OptiRO.ai colectează, utilizează și protejează datele personale în versiunea actuală MVP (Minimum Viable Product).
          </p>
          <p className="text-muted-foreground leading-relaxed">
            Pentru orice solicitare oficială: 📧 <a href="mailto:contactoptiro@gmail.com" className="text-primary hover:underline">contactoptiro@gmail.com</a>
          </p>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">1. Operatorul de date</h2>
            <p className="text-muted-foreground leading-relaxed">
              În faza actuală MVP, operatorul datelor colectate prin OptiRO.ai este:<br />
              <strong>OptiRO.ai</strong><br />
              Contact: <a href="mailto:contactoptiro@gmail.com" className="text-primary hover:underline">contactoptiro@gmail.com</a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">2. Ce date colectăm</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">În versiunea MVP colectăm exclusiv:</p>

            <h3 className="text-lg font-semibold text-foreground mb-2">Date introduse direct de utilizator:</h3>
            <ul className="list-disc list-inside text-muted-foreground space-y-2 mb-4">
              <li>Adresă de email</li>
              <li>URL-ul site-ului analizat</li>
            </ul>

            <h3 className="text-lg font-semibold text-foreground mb-2">Date tehnice minime:</h3>
            <ul className="list-disc list-inside text-muted-foreground space-y-2 mb-4">
              <li>IP (anonimizat automat de infrastructură)</li>
              <li>Informații standard despre browser</li>
              <li>Timpul accesării</li>
            </ul>

            <p className="text-muted-foreground leading-relaxed">
              ⚠️ <strong>Nu colectăm:</strong> parole, date bancare, CNP, informații personale sensibile.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">3. Scopul colectării datelor</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">Datele sunt utilizate exclusiv pentru:</p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2">
              <li>Generarea raportului SEO & GEO</li>
              <li>Trimiterea raportului prin email</li>
              <li>Notificarea lansării versiunii complete</li>
              <li>Comunicarea ofertelor legate de produs</li>
            </ul>
            <p className="text-muted-foreground leading-relaxed mt-4">
              Nu folosim datele pentru profilare agresivă. Nu vindem datele către terți. Nu transferăm datele în scop comercial.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">4. Temeiul legal al prelucrării</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">Prelucrăm datele în baza:</p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2">
              <li>✔️ Consimțământului explicit (introducerea email-ului pentru raport)</li>
              <li>✔️ Interesului legitim (funcționarea tehnică a platformei)</li>
            </ul>
            <p className="text-muted-foreground leading-relaxed mt-4">
              Utilizatorul poate retrage consimțământul în orice moment prin solicitare la: 📧 <a href="mailto:contactoptiro@gmail.com" className="text-primary hover:underline">contactoptiro@gmail.com</a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">5. Stocarea datelor</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">Datele sunt stocate:</p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2">
              <li>Pe servere securizate</li>
              <li>Utilizând servicii conforme GDPR</li>
              <li>Pe perioadă limitată necesară funcționării MVP-ului</li>
            </ul>
            <p className="text-muted-foreground leading-relaxed mt-4">
              Email-urile pot fi păstrate pentru notificarea lansării, până la solicitarea de ștergere.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">6. Drepturile utilizatorului (conform GDPR)</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">Orice utilizator are dreptul la:</p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2">
              <li><strong>Dreptul de acces</strong> la date</li>
              <li><strong>Dreptul la rectificare</strong></li>
              <li><strong>Dreptul la ștergere</strong> („dreptul de a fi uitat")</li>
              <li><strong>Dreptul la restricționarea</strong> prelucrării</li>
              <li><strong>Dreptul la portabilitate</strong></li>
              <li><strong>Dreptul la opoziție</strong></li>
            </ul>
            <p className="text-muted-foreground leading-relaxed mt-4">
              Pentru exercitarea acestor drepturi: 📧 <a href="mailto:contactoptiro@gmail.com" className="text-primary hover:underline">contactoptiro@gmail.com</a>
            </p>
            <p className="text-muted-foreground leading-relaxed mt-2">Răspundem solicitărilor în maximum 30 zile.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">7. Securitatea datelor</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">Aplicăm măsuri tehnice rezonabile:</p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2">
              <li>Conexiuni HTTPS</li>
              <li>Acces limitat la date</li>
              <li>Infrastructură securizată</li>
            </ul>
            <p className="text-muted-foreground leading-relaxed mt-4">Cu toate acestea, nicio platformă online nu poate garanta securitate absolută.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">8. Transfer internațional de date</h2>
            <p className="text-muted-foreground leading-relaxed">
              În cadrul MVP, anumite servicii tehnice (ex: infrastructură cloud sau procesare AI) pot implica transfer de date în afara UE. Aceste servicii sunt alese pe baza conformității cu standardele GDPR.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">9. Ștergerea datelor</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">Utilizatorul poate solicita:</p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2">
              <li>Ștergerea email-ului</li>
              <li>Eliminarea datelor asociate unui URL</li>
              <li>Dezabonarea din orice comunicare</li>
            </ul>
            <p className="text-muted-foreground leading-relaxed mt-4">
              Solicitările se trimit la: 📧 <a href="mailto:contactoptiro@gmail.com" className="text-primary hover:underline">contactoptiro@gmail.com</a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">10. Politica pentru minori</h2>
            <p className="text-muted-foreground leading-relaxed">
              Serviciul nu este destinat persoanelor sub 16 ani. Nu colectăm în mod intenționat date de la minori.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">11. Modificări viitoare</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Fiind o versiune MVP, această politică poate fi actualizată odată cu:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2">
              <li>Lansarea versiunii complete</li>
              <li>Introducerea abonamentelor</li>
              <li>Integrarea plăților</li>
              <li>Activarea optimizărilor automate</li>
            </ul>
            <p className="text-muted-foreground leading-relaxed mt-4">Orice modificare va fi afișată pe site.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">12. Contact</h2>
            <p className="text-muted-foreground leading-relaxed">
              Pentru orice aspect legat de protecția datelor: 📧 <a href="mailto:contactoptiro@gmail.com" className="text-primary hover:underline">contactoptiro@gmail.com</a>
            </p>
          </section>
        </div>
      </div>
    </PageLayout>
  );
};

export default Privacy;
